import { render, staticRenderFns } from "./payDataExport.vue?vue&type=template&id=97ea52de&scoped=true"
import script from "./payDataExport.vue?vue&type=script&lang=js"
export * from "./payDataExport.vue?vue&type=script&lang=js"
import style0 from "./payDataExport.vue?vue&type=style&index=0&id=97ea52de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ea52de",
  null
  
)

export default component.exports